/**
 * Generates time slots with a given interval.
 * @param {number} intervalMinutes - Interval in minutes (e.g., 30)
 * @returns {string[]} Array of time strings in "hh:mm A" format
 */
export const generateTimeSlots = (intervalMinutes = 30) => {
    const slots = [];
    let currentMinutes = 0;
    const totalMinutesInDay = 24 * 60;

    while (currentMinutes < totalMinutesInDay) {
        const hours = Math.floor(currentMinutes / 60);
        const minutes = currentMinutes % 60;

        const period = hours >= 12 ? "PM" : "AM";
        const displayHours = hours % 12 || 12;
        const displayMinutes = String(minutes).padStart(2, "0");

        slots.push(`${displayHours}:${displayMinutes} ${period}`);
        currentMinutes += intervalMinutes;
    }

    return slots;
};
